import React from 'react';
import styles from "./ModalLayout.less";

export default props => <div className={styles.modalLayout} style={{ minHeight: '400px' }} {...props} />;



// WEBPACK FOOTER //
// ./src/layouts/ModalLayout.js